import React from 'react';
import './styles.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh } from "@fortawesome/free-solid-svg-icons";
import { faVolumeXmark } from "@fortawesome/free-solid-svg-icons";
import Success from '../../../../assets/images/responseSuccess.png';
import Failed from '../../../../assets/images/responseFailed.png';

type QuestionProps = {
  activeNav: boolean,
  questions: any,
  question: any,
  isResponseSuccess: boolean

}
function Question({ activeNav, question, questions, isResponseSuccess }: QuestionProps) {  

  const synthese = window.speechSynthesis;
  const voices = window.speechSynthesis.getVoices();
  const frenchVoice = voices.find(voice => voice.lang === 'fr-FR');

  function attendre(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function ArreterLectureQuestion() {
    speechSynthesis.cancel();
    
    let boutonVolume = document.querySelector(".Question--btn-volume");
    if (boutonVolume) {
      boutonVolume.style.display = '';
    }
    
    let boutonVolumeOff = document.querySelector(".Question--btn-volume-off");
    if (boutonVolumeOff) {
      boutonVolumeOff.style.display = 'none';
    }
  }

  function ArreterLectureQuestionStatut() {
    speechSynthesis.cancel();
    
    let boutonStatutVolume = document.querySelector(".Question-status--btn-volume");
    if (boutonStatutVolume) {
      boutonStatutVolume.style.display = '';
    }
    
    let boutonStatutVolumeOff = document.querySelector(".Question-status--btn-volume-off");
    if (boutonStatutVolumeOff) {
      boutonStatutVolumeOff.style.display = 'none';
    }
  }

  async function lireTexteQuestion() {

    speechSynthesis.cancel();

    let boutonVolume = document.querySelector(".Question--btn-volume");
    if (boutonVolume) {
        boutonVolume.style.display = 'none';
    }

    let boutonVolumeOff = document.querySelector(".Question--btn-volume-off");
    if (boutonVolumeOff) {
        boutonVolumeOff.style.display = '';
    }

    let listeQuestions = document.getElementsByClassName("Question--contenu");
    if (listeQuestions.length === 1) {
      let texteQuestion = listeQuestions[0].innerText;
      let utteranceQuestion = new SpeechSynthesisUtterance(texteQuestion);
      utteranceQuestion.lang = 'fr-FR'; // Choix de la langue : ici, français

      if (frenchVoice) {
        utteranceQuestion.voice = frenchVoice;
      }

      speechSynthesis.speak(utteranceQuestion);
    }
    
    let listeReponses = document.getElementsByClassName("Answer--contenu");
    for (let compteurReponse = 0; compteurReponse < listeReponses.length; compteurReponse++) {
    
      let texteNumeroReponse = "Reponse ";
      switch(compteurReponse) {
        case 0:
          texteNumeroReponse = texteNumeroReponse + " A";
          break;
        case 1:
          texteNumeroReponse = texteNumeroReponse + " B";
          break;
        case 2:
          texteNumeroReponse = texteNumeroReponse + " C";
          break;
        case 3:
          texteNumeroReponse = texteNumeroReponse + " D";
          break;
        case 4:
          texteNumeroReponse = texteNumeroReponse + " E";
          break;
      }      
    
      let utteranceNumeroReponse = new SpeechSynthesisUtterance(texteNumeroReponse);
      utteranceNumeroReponse.lang = 'fr-FR'; // Choix de la langue : ici, français
      
      if (frenchVoice) {
        utteranceNumeroReponse.voice = frenchVoice;
      }

      speechSynthesis.speak(utteranceNumeroReponse);    
    
      // Attendre que la première soit terminée + pause
      await new Promise(resolve => {
        utteranceNumeroReponse.onend = async () => {
          await attendre(100);
          resolve();
        };
      });
    
      let texteReponse = listeReponses[compteurReponse].innerText;
      let utteranceReponse = new SpeechSynthesisUtterance(texteReponse);
      utteranceReponse.lang = 'fr-FR'; // Choix de la langue : ici, français
      
      if (frenchVoice) {
        utteranceReponse.voice = frenchVoice;
      }

      speechSynthesis.speak(utteranceReponse);
    }

    if (boutonVolume) {
      boutonVolume.style.display = '';
    }
    
    if (boutonVolumeOff) {
      boutonVolumeOff.style.display = 'none';
    }
  }

  async function lireTexteQuestionStatut() {

    speechSynthesis.cancel();

    let boutonStatutVolume = document.querySelector(".Question-status--btn-volume");
    if (boutonStatutVolume) {
      boutonStatutVolume.style.display = 'none';
    }

    let boutonStatutVolumeOff = document.querySelector(".Question-status--btn-volume-off");
    if (boutonStatutVolumeOff) {
      boutonStatutVolumeOff.style.display = '';
    }
    
    let questionsStatut = document.getElementsByClassName("Question-status--contenu");
    if (questionsStatut.length === 1) {
      let texteQuestionStatut = questionsStatut[0].innerText;
      let utteranceQuestionStatut = new SpeechSynthesisUtterance(texteQuestionStatut);
      utteranceQuestionStatut.lang = 'fr-FR'; // Choix de la langue : ici, français

      if (frenchVoice) {
        utteranceQuestionStatut.voice = frenchVoice;
      }

      speechSynthesis.speak(utteranceQuestionStatut);
      
      // Attendre que la première soit terminée + pause
      await new Promise(resolve => {
        utteranceQuestionStatut.onend = async () => {
          await attendre(50);
          resolve();
        };
      });
    }
        
    if (boutonStatutVolume) {
      boutonStatutVolume.style.display = '';
    }
    
    if (boutonStatutVolumeOff) {
      boutonStatutVolumeOff.style.display = 'none';
    }
  }

  return (
    <div className="Question">
        <div className={!activeNav ? 'Question-welcome' : 'Question-welcome--blur'}>
          <h2 className="Question--title">
            {question && question.Formation.name}
          </h2>
          <p className="Question--number">
            {question && question.number} 
            <span className="Question--number-length">/ 
              {questions && questions.length} 
            </span>
          </p>
          <p className="Question--text">
            <span className="Question--contenu">{question && question.intro_text_panel}</span>
            <span>
              <button onClick={lireTexteQuestion} className="Question--btn-volume">
                <FontAwesomeIcon icon={faVolumeHigh} style={{marginRight: '0.5rem', height: '1rem'}}/>
              </button>
            </span>
            <span>
              <button onClick={ArreterLectureQuestion} className="Question--btn-volume-off" style={{display:'none'}}>
                <FontAwesomeIcon icon={faVolumeXmark} style={{marginRight: '0.5rem', height: '1rem'}}/>
              </button>
            </span>
          </p>
          {isResponseSuccess === true && (
            <>
              <div className='Question-status'>
                <img className="Question-status--image" src={Success} alt="success" />
                <span style={{color: '#26A653'}}>Bien joué !</span>
              </div>
              <p className="Question-status--text">
                <span className="Question-status--contenu" dangerouslySetInnerHTML={{ __html: `${question.final_text_panel.replace(/\n/g, '<br/>')}`}}></span>
                <span>
                  <button onClick={lireTexteQuestionStatut} className="Question-status--btn-volume">
                    <FontAwesomeIcon icon={faVolumeHigh} style={{marginRight: '0.5rem', height: '1rem'}}/>
                  </button>
                </span>
                <span>
                  <button onClick={ArreterLectureQuestionStatut} className="Question-status--btn-volume-off" style={{display:'none'}}>
                    <FontAwesomeIcon icon={faVolumeXmark} style={{marginRight: '0.5rem', height: '1rem'}}/>
                  </button>
                </span>
              </p>
            </>
          )}
          {isResponseSuccess === false && (
            <>
              <div className='Question-status'>
                <img className="Question-status--image" src={Failed} alt="failed" />
                <span style={{color: '#E70F47'}}>Mauvaise réponse !</span>
              </div>
              
              <p className="Question-status--text">
                <span className="Question-status--contenu" dangerouslySetInnerHTML={{ __html: `${question.final_text_panel.replace(/\n/g, '<br/>')}`}}></span>
                <span>
                  <button onClick={lireTexteQuestionStatut} className="Question-status--btn-volume">
                    <FontAwesomeIcon icon={faVolumeHigh} style={{marginRight: '0.5rem', height: '1rem'}}/>
                  </button>
                </span>
                <span>
                  <button onClick={ArreterLectureQuestionStatut} className="Question-status--btn-volume-off" style={{display:'none'}}>
                    <FontAwesomeIcon icon={faVolumeXmark} style={{marginRight: '0.5rem', height: '1rem'}}/>
                  </button>
                </span>
              </p>
            </>
          )}
        </div>
    </div>
  );
}

export default Question;
